module.exports = __webpack_public_path__ + "img/FRISS_logo.f2c258b4.png";